import { Injectable } from '@angular/core';
import {BackendService} from "./backend.service";
import {Observable} from "rxjs";
import {map} from "rxjs/operators";
import {ResponseDto} from "../dto/response.dto";

@Injectable({
  providedIn: 'root'
})
export class ZoneService {

  private urlPrefix = '/api/zone';

  constructor(private backend: BackendService) {}

  getZoneList(cityCode: string): Observable<any> {
    const url = `${this.urlPrefix}/list/city/${cityCode}`;
    return this.backend.get(url).pipe(
        map((response: ResponseDto) => response.response)
    );
  }

    getZonePriceList(cityId: number, segmentId: number, adId: number): Observable<any> {
        const url = `${this.urlPrefix}/list/price/${cityId}/${segmentId}/${adId}`;
        return this.backend.get(url).pipe(
            map((response: ResponseDto) => response.response)
        );
    }

    getZonePrice(zoneId: number, segmentId: number, adId: number  ): Observable<any> {
        const url = `${this.urlPrefix}/price/${zoneId}/${segmentId}/${adId}`;
        return this.backend.get(url).pipe(
            map((response: ResponseDto) => response.response)
        );
    }
}
